module.exports = __webpack_public_path__ + "static/img/file_yaml.c50b47d0.png";